module.exports = __webpack_public_path__ + "img/icon_user_pink_primary.9fc3825e.svg";